export default "__VITE_ASSET__DEbmbJ____"